



























































































































































































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faCircle } from '@fortawesome/free-regular-svg-icons/faCircle';
import { faDotCircle } from '@fortawesome/free-regular-svg-icons/faDotCircle';

import bButton from 'bootstrap-vue/es/components/button/button';
import bCard from 'bootstrap-vue/es/components/card/card';
import bCardHeader from 'bootstrap-vue/es/components/card/card-header';
import bListGroup from 'bootstrap-vue/es/components/list-group/list-group';
import bListGroupItem from 'bootstrap-vue/es/components/list-group/list-group-item';
import bCollapse from 'bootstrap-vue/es/components/collapse/collapse';

import {
  Address,
  DraftFulfillment,
  FulfillmentService,
} from '@/models';
import { formatAddress } from '@/lib/address';

import BottomPanel from '@/components/BottomPanel.vue';
import PriceBlock from '@/components/PriceBlock.vue';

const MobileFulfillmentSelectionFormProps = Vue.extend({
  props: {
    fulfillment: {
      type: DraftFulfillment,
      required: true,
    },
  },
});

@Component({
  components: {
    BottomPanel,
    FontAwesomeIcon,
    PriceBlock,

    bButton,
    bCard,
    bCardHeader,
    bCollapse,
    bListGroup,
    bListGroupItem,
  },
})
export default class MobileFulfillmentSelectionForm extends MobileFulfillmentSelectionFormProps {
  public readonly faChevronDown = faChevronDown;
  public readonly faChevronRight = faChevronRight;
  public readonly faChevronUp = faChevronUp;
  public readonly faCircle = faCircle;
  public readonly faDotCircle = faDotCircle;

  public selected = this.fulfillment.service.id;
  public selectedAddress = this.fulfillment.shippingAddress;

  public accordionId(option: { service: FulfillmentService }) {
    return `fulfillment-accordion-${option.service.id}`;
  }

  public selectFulfillment(option: {
    service: FulfillmentService,
    addresses: Address[],
  }) {
    if (this.selected !== option.service.id) {
      const prevSelected = this.selected;
      this.selected = option.service.id;
      if (option.service === this.fulfillment.service) {
        this.selectedAddress = this.fulfillment.shippingAddress;
      } else if (option.addresses.length > 0) {
        this.selectedAddress = option.addresses[0];
      } else {
        this.selectedAddress = undefined;
      }
      this.$root.$emit('bv::toggle::collapse', this.accordionId(option));
    }
  }

  public formatAddress(address: Address) {
    return formatAddress(address);
  }

  public isSelected(option: { service: FulfillmentService }) {
    return option.service.id === this.selected;
  }

  public submit() {
    if (this.selected === this.fulfillment.service.id &&
        (!this.selectedAddress || this.selectedAddress === this.fulfillment.shippingAddress)) {
      // There's no any change.
      this.cancel();
    } else {
      this.$emit('submit', {
        fulfillment: this.fulfillment,
        selected: this.selected,
        selectedAddress: this.selectedAddress,
      });
    }
  }

  public cancel() {
    this.$emit('cancel');
  }
}

